import gql from "graphql-tag";
import { paymentMethod } from "../fragments/payment";

export const workspacePaymentMethods = gql`
  query GetWorkspacePaymentMethodsQuery($workspaceId: UUID!) {
    workspace: getWorkspace(id: $workspaceId) {
      id
      paymentMethods {
        ...PaymentMethod
      }
    }
  }

  ${paymentMethod}
`;

export const organizationPaymentMethods = gql`
  query GetOrganizationPaymentMethodsQuery($organizationId: UUID!) {
    organization: getOrganization(id: $organizationId) {
      id
      workspaces {
        id
        paymentMethods {
          ...PaymentMethod
        }
      }
    }
  }

  ${paymentMethod}
`;
